import React from 'react'
import {TrashIcon} from "@heroicons/react/24/solid";

const ClearButton = ({handleClear}) => {

    return (
        <>
            <button
                onClick={() => handleClear()}
                className="rounded flex items-center justify-center border-gray-500 border bg-white text-gray-500 h-10 w-10 hover:bg-gray-500 hover:text-white">
                <div className="p-4">
                    <TrashIcon className="h-6 w-6"/>
                </div>
            </button>
        </>
    )
}

export default ClearButton
